module.exports = __webpack_public_path__ + "img/icon_app.a246a94c.png";